/**
 * 格式化日期时间(包含秒数)
 * @param {String|Date} datetime 日期时间字符串或Date对象
 * @returns {String} 格式化后的日期时间字符串
 */
export function formatDateTime(datetime) {
  if (!datetime) return "";
  const date = new Date(datetime);
  return `${date.getFullYear()}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")} ${date
    .getHours()
    .toString()
    .padStart(2, "0")}:${date
    .getMinutes()
    .toString()
    .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;
}